import axios from 'axios';
import create from 'zustand';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

const useStore = create((set, get) => ({
    keywords_response: undefined,
    setkeywords_response: (data) => set({ keywords_response: data })
}));

export default useStore;